// extracted by mini-css-extract-plugin
export default {"container":"SelectWasteTypes_container__kttiS","title":"SelectWasteTypes_title__Yp5hj","containerTypes":"SelectWasteTypes_containerTypes__E4ZJP"};